import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fields from "models/massModuleUpdate"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import _ from "lodash"
import { toast } from "react-toastify"

class MassModuleUpdate extends Component {
	constructor(props) {
		super(props)
		this.state = {
			ready: false,
			fields,
		}
	}

	validation = () => {
		return Yup.object().shape({
			action: Yup.string().required("Required"),
			users: Yup.array().typeError('Please select at least one user.').min(1, "Please select at least one user.").required("Required"),
			modules: Yup.array().typeError('Please select at least one module.').min(1, "Please select at least one module.").required("Required"),
		})
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	listUsers = () => {
		let ret = []
		_.forEach(this.props.payload.users, (v) => {
			if (!v.status || v.group !== 1) return
			ret.push({
				label: `${v.first} ${v.last}`,
				value: v.id,
			})
		})
		ret = _.sortBy(ret, "label")
		return ret
	}

	listModules = () => {
		let ret = []
		_.forEach(this.props.payload.public.loadedModules, (v) => {
			ret.push({
				label: v.long_name || v.name,
				value: v.id,
			})
		})
		ret = _.sortBy(ret, "label")
		return ret
	}

	render() {
		const { open } = this.props
		return (
			<div>
				<Modal open={open} onClose={this.props.onClose} center classNames={{ modal: "pipsyModal__min" }}>
					<h3>Mass Component Update</h3>
					<Formik
						enableReinitialize
						initialValues={this.state.fields}
						validateOnMount={true}
						validationSchema={this.validation}
						onSubmit={(values) => {
							this.props.loadingStatus(true)
							submitData("massUpdateModules", values).then((data) => {
								this.props.loadingStatus(false)
								toast.success(data.message)
								this.props.close()
								this.setState(
									{
										redirect: true,
										redirectPath: data.redirect,
									},
									() => {
										this.props.getPayload()
									}
								)
							})
						}}
						render={(f) => (
							<div className="">
								<div className="content">
									<Form>
										{/* console.log(f) */}
										<ul className="form__list">
											<li className={fieldStatus("action", f, false, false, true)}>
												<label htmlFor="action">
													Action <sup>*</sup>
												</label>
												{f.errors.action && f.touched.action && (
													<div className="form__message">{f.errors.action}</div>
												)}
												<ReactSelect
													name={`action`}
													options={[
														{ value: "remove", label: "Remove Modules" },
														{ value: "add", label: "Add Modules" },
													]}
													value={f.values.action}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("users", f, false, false, true)}>
												<label htmlFor="users">
													Users <sup>*</sup>
												</label>
												{f.errors.users && f.touched.users && (
													<div className="form__message">{f.errors.users}</div>
												)}
												<ReactSelect
													name={`users`}
													options={this.listUsers()}
													isMulti
													value={f.values.users}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("modules", f, false, false, true)}>
												<label htmlFor="modules">
													Modules <sup>*</sup>
												</label>
												{f.errors.modules && f.touched.modules && (
													<div className="form__message">{f.errors.modules}</div>
												)}
												<ReactSelect
													name={`modules`}
													options={this.listModules()}
													isMulti
													value={f.values.modules}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
										</ul>
										<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
									</Form>
								</div>
							</div>
						)}
					/>
				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(MassModuleUpdate)
